import React, { useEffect, useState } from 'react';
import { Paper, Grid, Button, Typography, TextField } from '@mui/material';

import SaveIcon from '@mui/icons-material/Save';
import { useAppDispatch, useAppSelector } from '@redux/stores/hooks';
import { fetchTemplate, updateTemplate } from '@redux/actions/templates';
import { useParams } from 'react-router';
import { ROUTES } from '@components/consts';
import { Code } from '@components/types/templates/types';
import { RootState } from '@redux/reducers';
import { initialStateCode } from './editors/components/initialStateCode';
import { Editors } from './editors';
import { GalletyPreview } from './galleryPreview.component';
import { Navigate } from 'react-router-dom';

export const UpdateTemplate: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useAppDispatch();
  const template = useAppSelector((state: RootState) => state.templates).find(
    (t) => t._id === id,
  );
  const [name, setName] = useState('');
  const [code, setCode] = useState<Code>(initialStateCode);

  useEffect(() => {
    dispatch(fetchTemplate(id));
  }, [id, dispatch]);

  useEffect(() => {
    if (template?.name) {
      setName(template.name);
    }
  }, [template]);

  return (
    <Grid sx={{
      width: '100%',
      padding: '10px',
      '& hr': {
        margin: '10px auto',
      },
    }} container spacing={1}>
      <Grid item xs={12}>
        <Paper sx={{
          padding: '10px',
          display: 'flex',
          overflow: 'auto',
          flexDirection: 'column',
        }}>
          <Typography
            component="h1"
            variant="h6"
            color="inherit"
            noWrap
            sx={{
              flexGrow: 1,
              marginBottom: '10px',
            }}
          >
            Edytuj szablon
          </Typography>
          <TextField
            placeholder="Nazwa szablonu"
            value={name}
            onChange={(e) => setName(e.target.value)}
            sx={{ mt: 2, mb: 2 }}
          ></TextField>
          <Editors setCode={setCode} />
          <Button
            fullWidth
            color="primary"
            variant="contained"
            onClick={() => {
              dispatch(
                updateTemplate(id, {
                  name: name,
                  code: code,
                }),
              );
              return <Navigate to={ROUTES.templates.href} />;
            }}
            startIcon={<SaveIcon />}
          >
            Zapisz
          </Button>
        </Paper>
        <GalletyPreview code={code} />
      </Grid>
    </Grid>
  );
};
